import { createLocalStorageHelper } from './localstorage-helper';

export const orderLinesLocalStorageHelper = createLocalStorageHelper({
  name: 'orderLinesCount',
  updateEventName: 'shopping-badge-update',
  initialValue: 0,
  parse: (raw) => parseInt(raw) || 0,
  serialize: (value) => String(Math.max(0, Math.floor(value))),
});

export const orderLinesLastSyncLocalStorageHelper = createLocalStorageHelper({
  name: 'orderLinesLastSync',
  updateEventName: 'shopping-badge-last-sync',
  initialValue: 0,
  parse: (raw) => parseInt(raw) || 0,
  serialize: String,
});

export const invalidateOrderLinesSync = () => orderLinesLastSyncLocalStorageHelper.save(0);

export const wishlistLocalStorageHelper = createLocalStorageHelper({
  name: 'userWishlist',
  updateEventName: 'wishlist-update',
  initialValue: [],
  parse: (raw) => {
    try {
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  },
  serialize: JSON.stringify,
});
